import * as classic from './classic/index.js';
import * as historical from './historical/index.js';
import * as futuristic from './futuristic/index.js';
import * as naval from './naval/index.js';

// Visual themes. Each one supplies its own scene, entity classes and wording;
// gameplay is identical because the server is authoritative. The server picks
// each match's theme from the players' preferences, like the map.
export const THEMES = [classic, futuristic, historical, naval];

const STORAGE_KEY = 'arena-theme';
const DEFAULT_THEME = 'historical';

export function isThemeId(id) {
  return THEMES.some(t => t.id === id);
}

// The player's own preference: used in the lobby and sent as their vote when
// starting a match. The match itself may end up in a different theme.
export function getPreferredThemeId() {
  let id = null;
  try {
    id = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    // Storage can be unavailable (private mode); fall back to the default
  }
  return isThemeId(id) ? id : DEFAULT_THEME;
}

export function setPreferredThemeId(id) {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch (e) {
    // Ignore: the choice just won't persist
  }
}

let current = null;

// The theme currently on screen
export function getTheme() {
  if (!current) {
    current = THEMES.find(t => t.id === getPreferredThemeId());
  }
  return current;
}

// Switch the theme on screen. Returns true if it changed.
export function setActiveTheme(id) {
  const next = THEMES.find(t => t.id === id);
  if (!next || next === getTheme()) return false;
  current = next;
  return true;
}

// Server messages are written in plain (classic) language; themes reword them.
export function translateMessage(message) {
  const theme = getTheme();
  if (!message || !theme.messages) return message;
  return theme.messages.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), message);
}
